var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseLs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseLS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.8270184,18.9000183 L70.6080051,16.1190284 C70.8639983,15.8630349 70.8639983,15.4479886 70.6080051,15.1920317 C70.352012,14.9360383 69.9370027,14.9360383 69.6810096,15.1920317 L66.8999863,17.9730583 L64.118963,15.1919951 C63.8629698,14.9360016 63.4479606,14.9360016 63.1919674,15.1919951 C62.9360109,15.4479886 62.9360109,15.8630349 63.1919674,16.1189917 L65.9729907,18.8999817 L63.1919674,21.6810083 C62.9360109,21.9370017 62.9360109,22.3520481 63.1919674,22.6080049 C63.4479606,22.8639984 63.8629698,22.8639984 64.118963,22.6080049 L66.8999863,19.8269783 L69.6810096,22.6080049 C69.9369661,22.8639984 70.352012,22.8639984 70.6080051,22.6080049 C70.8639983,22.3520114 70.8639983,21.9370017 70.6080051,21.6810083 L67.8270184,18.9000183 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-63.000000, -15.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icCloseLS",
    fill: "#7BCB45",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseLs);
export default __webpack_public_path__ + "static/media/icCloseLS.f466412a874c912a9b23ceba821e760d.svg";
export { ForwardRef as ReactComponent };